import _slicedToArray from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import { randomUUID } from "@azure/core-util";
import { isTokenCredential } from "@azure/core-auth";
import { bearerTokenAuthenticationPolicy, createEmptyPipeline, createHttpHeaders } from "@azure/core-rest-pipeline";
import { isNode } from "@azure/core-util";
import { AnonymousCredential } from "./credentials/AnonymousCredential";
import { BlobClient } from "./Clients";
import { Mutex } from "./utils/Mutex";
import { Pipeline } from "./Pipeline";
import { getURLPath, getURLPathAndQuery, iEqual } from "./utils/utils.common";
import { stringifyXML } from "@azure/core-xml";
import { HeaderConstants, BATCH_MAX_REQUEST, HTTP_VERSION_1_1, HTTP_LINE_ENDING, StorageOAuthScopes } from "./utils/constants";
import { StorageSharedKeyCredential } from "./credentials/StorageSharedKeyCredential";
import { tracingClient } from "./utils/tracing";
import { authorizeRequestOnTenantChallenge, serializationPolicy } from "@azure/core-client";
import { storageSharedKeyCredentialPolicy } from "./policies/StorageSharedKeyCredentialPolicyV2";
/**
 * A BlobBatch represents an aggregated set of operations on blobs.
 * Currently, only `delete` and `setAccessTier` are supported.
 */

export var BlobBatch = /*#__PURE__*/function () {
  function BlobBatch() {
    _classCallCheck(this, BlobBatch);

    this.batch = "batch";
    this.batchRequest = new InnerBatchRequest();
  }
  /**
   * Get the value of Content-Type for a batch request.
   * The value must be multipart/mixed with a batch boundary.
   * Example: multipart/mixed; boundary=batch_a81786c8-e301-4e42-a729-a32ca24ae252
   */


  _createClass(BlobBatch, [{
    key: "getMultiPartContentType",
    value: function getMultiPartContentType() {
      return this.batchRequest.getMultipartContentType();
    }
    /**
     * Get assembled HTTP request body for sub requests.
     */

  }, {
    key: "getHttpRequestBody",
    value: function getHttpRequestBody() {
      return this.batchRequest.getHttpRequestBody();
    }
    /**
     * Get sub requests that are added into the batch request.
     */

  }, {
    key: "getSubRequests",
    value: function getSubRequests() {
      return this.batchRequest.getSubRequests();
    }
  }, {
    key: "addSubRequestInternal",
    value: function () {
      var _addSubRequestInternal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(subRequest, assembleSubRequestFunc) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Mutex.lock(this.batch);

              case 2:
                _context.prev = 2;
                this.batchRequest.preAddSubRequest(subRequest);
                _context.next = 6;
                return assembleSubRequestFunc();

              case 6:
                this.batchRequest.postAddSubRequest(subRequest);

              case 7:
                _context.prev = 7;
                _context.next = 10;
                return Mutex.unlock(this.batch);

              case 10:
                return _context.finish(7);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2,, 7, 11]]);
      }));

      function addSubRequestInternal(_x, _x2) {
        return _addSubRequestInternal.apply(this, arguments);
      }

      return addSubRequestInternal;
    }()
  }, {
    key: "setBatchType",
    value: function setBatchType(batchType) {
      if (!this.batchType) {
        this.batchType = batchType;
      }

      if (this.batchType !== batchType) {
        throw new RangeError("BlobBatch only supports one operation type per batch and it already is being used for ".concat(this.batchType, " operations."));
      }
    }
  }, {
    key: "deleteBlob",
    value: function () {
      var _deleteBlob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(urlOrBlobClient, credentialOrOptions, options) {
        var _this = this;

        var url, credential;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(typeof urlOrBlobClient === "string" && (isNode && credentialOrOptions instanceof StorageSharedKeyCredential || credentialOrOptions instanceof AnonymousCredential || isTokenCredential(credentialOrOptions)))) {
                  _context4.next = 5;
                  break;
                }

                // First overload
                url = urlOrBlobClient;
                credential = credentialOrOptions;
                _context4.next = 12;
                break;

              case 5:
                if (!(urlOrBlobClient instanceof BlobClient)) {
                  _context4.next = 11;
                  break;
                }

                // Second overload
                url = urlOrBlobClient.url;
                credential = urlOrBlobClient.credential;
                options = credentialOrOptions;
                _context4.next = 12;
                break;

              case 11:
                throw new RangeError("Invalid arguments. Either url and credential, or BlobClient need be provided.");

              case 12:
                if (!options) {
                  options = {};
                }

                return _context4.abrupt("return", tracingClient.withSpan("BatchDeleteRequest-addSubRequest", options, /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(updatedOptions) {
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _this.setBatchType("delete");

                            _context3.next = 3;
                            return _this.addSubRequestInternal({
                              url: url,
                              credential: credential
                            }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                                while (1) {
                                  switch (_context2.prev = _context2.next) {
                                    case 0:
                                      _context2.next = 2;
                                      return new BlobClient(url, _this.batchRequest.createPipeline(credential)).delete(updatedOptions);

                                    case 2:
                                    case "end":
                                      return _context2.stop();
                                  }
                                }
                              }, _callee2);
                            })));

                          case 3:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x6) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function deleteBlob(_x3, _x4, _x5) {
        return _deleteBlob.apply(this, arguments);
      }

      return deleteBlob;
    }()
  }, {
    key: "setBlobAccessTier",
    value: function () {
      var _setBlobAccessTier = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(urlOrBlobClient, credentialOrTier, tierOrOptions, options) {
        var _this2 = this;

        var url, credential, tier;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(typeof urlOrBlobClient === "string" && (isNode && credentialOrTier instanceof StorageSharedKeyCredential || credentialOrTier instanceof AnonymousCredential || isTokenCredential(credentialOrTier)))) {
                  _context7.next = 6;
                  break;
                }

                // First overload
                url = urlOrBlobClient;
                credential = credentialOrTier;
                tier = tierOrOptions;
                _context7.next = 14;
                break;

              case 6:
                if (!(urlOrBlobClient instanceof BlobClient)) {
                  _context7.next = 13;
                  break;
                }

                // Second overload
                url = urlOrBlobClient.url;
                credential = urlOrBlobClient.credential;
                tier = credentialOrTier;
                options = tierOrOptions;
                _context7.next = 14;
                break;

              case 13:
                throw new RangeError("Invalid arguments. Either url and credential, or BlobClient need be provided.");

              case 14:
                if (!options) {
                  options = {};
                }

                return _context7.abrupt("return", tracingClient.withSpan("BatchSetTierRequest-addSubRequest", options, /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(updatedOptions) {
                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _this2.setBatchType("setAccessTier");

                            _context6.next = 3;
                            return _this2.addSubRequestInternal({
                              url: url,
                              credential: credential
                            }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                              return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                                while (1) {
                                  switch (_context5.prev = _context5.next) {
                                    case 0:
                                      _context5.next = 2;
                                      return new BlobClient(url, _this2.batchRequest.createPipeline(credential)).setAccessTier(tier, updatedOptions);

                                    case 2:
                                    case "end":
                                      return _context5.stop();
                                  }
                                }
                              }, _callee5);
                            })));

                          case 3:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));

                  return function (_x11) {
                    return _ref3.apply(this, arguments);
                  };
                }()));

              case 16:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function setBlobAccessTier(_x7, _x8, _x9, _x10) {
        return _setBlobAccessTier.apply(this, arguments);
      }

      return setBlobAccessTier;
    }()
  }]);

  return BlobBatch;
}();
/**
 * Inner batch request class which is responsible for assembling and serializing sub requests.
 * See https://docs.microsoft.com/en-us/rest/api/storageservices/blob-batch#request-body for how requests are assembled.
 */

var InnerBatchRequest = /*#__PURE__*/function () {
  function InnerBatchRequest() {
    _classCallCheck(this, InnerBatchRequest);

    this.operationCount = 0;
    this.body = "";
    var tempGuid = randomUUID(); // batch_{batchid}

    this.boundary = "batch_".concat(tempGuid); // --batch_{batchid}
    // Content-Type: application/http
    // Content-Transfer-Encoding: binary

    this.subRequestPrefix = "--".concat(this.boundary).concat(HTTP_LINE_ENDING).concat(HeaderConstants.CONTENT_TYPE, ": application/http").concat(HTTP_LINE_ENDING).concat(HeaderConstants.CONTENT_TRANSFER_ENCODING, ": binary"); // multipart/mixed; boundary=batch_{batchid}

    this.multipartContentType = "multipart/mixed; boundary=".concat(this.boundary); // --batch_{batchid}--

    this.batchRequestEnding = "--".concat(this.boundary, "--");
    this.subRequests = new Map();
  }
  /**
   * Create pipeline to assemble sub requests. The idea here is to use existing
   * credential and serialization/deserialization components, with additional policies to
   * filter unnecessary headers, assemble sub requests into request's body
   * and intercept request from going to wire.
   * @param credential -  Such as AnonymousCredential, StorageSharedKeyCredential or any credential from the `@azure/identity` package to authenticate requests to the service. You can also provide an object that implements the TokenCredential interface. If not specified, AnonymousCredential is used.
   */


  _createClass(InnerBatchRequest, [{
    key: "createPipeline",
    value: function createPipeline(credential) {
      var corePipeline = createEmptyPipeline();
      corePipeline.addPolicy(serializationPolicy({
        stringifyXML: stringifyXML,
        serializerOptions: {
          xml: {
            xmlCharKey: "#"
          }
        }
      }), {
        phase: "Serialize"
      }); // Use batch header filter policy to exclude unnecessary headers

      corePipeline.addPolicy(batchHeaderFilterPolicy()); // Use batch assemble policy to assemble request and intercept request from going to wire

      corePipeline.addPolicy(batchRequestAssemblePolicy(this), {
        afterPhase: "Sign"
      });

      if (isTokenCredential(credential)) {
        corePipeline.addPolicy(bearerTokenAuthenticationPolicy({
          credential: credential,
          scopes: StorageOAuthScopes,
          challengeCallbacks: {
            authorizeRequestOnChallenge: authorizeRequestOnTenantChallenge
          }
        }), {
          phase: "Sign"
        });
      } else if (credential instanceof StorageSharedKeyCredential) {
        corePipeline.addPolicy(storageSharedKeyCredentialPolicy({
          accountName: credential.accountName,
          accountKey: credential.accountKey
        }), {
          phase: "Sign"
        });
      }

      var pipeline = new Pipeline([]); // attach the v2 pipeline to this one

      pipeline._credential = credential;
      pipeline._corePipeline = corePipeline;
      return pipeline;
    }
  }, {
    key: "appendSubRequestToBody",
    value: function appendSubRequestToBody(request) {
      // Start to assemble sub request
      this.body += [this.subRequestPrefix, // sub request constant prefix
      "".concat(HeaderConstants.CONTENT_ID, ": ").concat(this.operationCount), // sub request's content ID
      "", // empty line after sub request's content ID
      "".concat(request.method.toString(), " ").concat(getURLPathAndQuery(request.url), " ").concat(HTTP_VERSION_1_1).concat(HTTP_LINE_ENDING) // sub request start line with method
      ].join(HTTP_LINE_ENDING);

      var _iterator = _createForOfIteratorHelper(request.headers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              name = _step$value[0],
              value = _step$value[1];

          this.body += "".concat(name, ": ").concat(value).concat(HTTP_LINE_ENDING);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.body += HTTP_LINE_ENDING; // sub request's headers need be ending with an empty line
      // No body to assemble for current batch request support
      // End to assemble sub request
    }
  }, {
    key: "preAddSubRequest",
    value: function preAddSubRequest(subRequest) {
      if (this.operationCount >= BATCH_MAX_REQUEST) {
        throw new RangeError("Cannot exceed ".concat(BATCH_MAX_REQUEST, " sub requests in a single batch"));
      } // Fast fail if url for sub request is invalid


      var path = getURLPath(subRequest.url);

      if (!path || path === "") {
        throw new RangeError("Invalid url for sub request: '".concat(subRequest.url, "'"));
      }
    }
  }, {
    key: "postAddSubRequest",
    value: function postAddSubRequest(subRequest) {
      this.subRequests.set(this.operationCount, subRequest);
      this.operationCount++;
    } // Return the http request body with assembling the ending line to the sub request body.

  }, {
    key: "getHttpRequestBody",
    value: function getHttpRequestBody() {
      return "".concat(this.body).concat(this.batchRequestEnding).concat(HTTP_LINE_ENDING);
    }
  }, {
    key: "getMultipartContentType",
    value: function getMultipartContentType() {
      return this.multipartContentType;
    }
  }, {
    key: "getSubRequests",
    value: function getSubRequests() {
      return this.subRequests;
    }
  }]);

  return InnerBatchRequest;
}();

function batchRequestAssemblePolicy(batchRequest) {
  return {
    name: "batchRequestAssemblePolicy",
    sendRequest: function () {
      var _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(request) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                batchRequest.appendSubRequestToBody(request);
                return _context8.abrupt("return", {
                  request: request,
                  status: 200,
                  headers: createHttpHeaders()
                });

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function sendRequest(_x12) {
        return _sendRequest.apply(this, arguments);
      }

      return sendRequest;
    }()
  };
}

function batchHeaderFilterPolicy() {
  return {
    name: "batchHeaderFilterPolicy",
    sendRequest: function () {
      var _sendRequest2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(request, next) {
        var xMsHeaderName, _iterator2, _step2, _step2$value, name;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                xMsHeaderName = "";
                _iterator2 = _createForOfIteratorHelper(request.headers);

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    _step2$value = _slicedToArray(_step2.value, 1), name = _step2$value[0];

                    if (iEqual(name, HeaderConstants.X_MS_VERSION)) {
                      xMsHeaderName = name;
                    }
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }

                if (xMsHeaderName !== "") {
                  request.headers.delete(xMsHeaderName); // The subrequests should not have the x-ms-version header.
                }

                return _context9.abrupt("return", next(request));

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function sendRequest(_x13, _x14) {
        return _sendRequest2.apply(this, arguments);
      }

      return sendRequest;
    }()
  };
}